export function syncHeadlines() {
  document.querySelectorAll(".pipechain-sync-headlines").forEach((wrapper) => {
    // iterate over columns
    let minHeight = 0;
    let allYAlign = true;
    let yPos: number | null = null;
    let headlines: HTMLHeadingElement[] = [];
    wrapper.querySelectorAll(".wp-block-column").forEach((col) => {
      const firstHeadline: HTMLHeadingElement = col.querySelector(
        "h1, h2, h3, h4, h5, h6",
      ) as HTMLHeadingElement;
      if (firstHeadline) {
        firstHeadline.style.minHeight = `0`;
        minHeight = Math.max(minHeight, firstHeadline.clientHeight);
        headlines.push(firstHeadline);
      }
      const rect = firstHeadline.getClientRects()[0];
      if (allYAlign) {
        if (yPos === null) {
          yPos = rect.y;
        } else {
          if (yPos !== rect.y) {
            allYAlign = false;
          }
        }
      }
    });
    if (allYAlign) {
      // console.log("All headlines are aligned vertically.");
      for (const headline of headlines) {
        headline.style.minHeight = `${minHeight}px`;
      }
    } else {
      // console.log("Not all headlines are aligned vertically.");
    }
  });
}
